import { logEvent } from './logGaEvent'

const logUpdateSearch = ({ pageName, changed = [] }) => {
  logEvent('select_item', {
    item_name: 'update_search',
    product_name: 'air',
    page_name: pageName,
    search_update_type: changed.join('_').toLowerCase() || 'none',
  })
}

export { logUpdateSearch }
